import { get } from 'underscore';

function getByPath<T>(object: Record<string, T>, path: string, separator = '.') {
    return get(object, path.split(separator));
}

export const ObjectUtil = {
    getByPath
};
